import React, {createContext, useContext} from "react"
import {useTranslation} from "react-i18next"
import {ProgressIndicator} from "../app/ProgressIndicator"

const DashboardTranslationContext = createContext(undefined)

export const DashboardTranslationProvider = ({children}) => {
    const {t, ready} = useTranslation("bpn.dashboard", {useSuspense: false})

    if (ready) {
        return (
            <DashboardTranslationContext.Provider value={t}>
                {children}
            </DashboardTranslationContext.Provider>
        )
    } else {
        return <ProgressIndicator/>
    }
}

export const useDashboardTranslation = () => {
    return useContext(DashboardTranslationContext)
}